import { getBaseUrl } from '@gik/core/utils/LinkUtils';
import { AnchorLink, Button, Heading, SvgIcon } from '@gik/ui';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { translationKeys } from '@gik/inkind-page/i18n/en';
import bemBlock from '@gik/core/utils/bemBlock';
import { openSendAGiftBoxModal } from '../SendAGiftBoxModal';
import Link from '@/components/Link';
import { getInkindPageViewHistory } from '../InkindPageViewRecorder/InkindPageViewRecorder';
import { useInkind } from '@gik/api/inkinds/inkind';

export interface ISupportButtonsProps {
  inkindRouteId: string;
}

// TODO please remove inline styles and/or fonticon upon migrating this to SPA
export default function SupportButtons({ inkindRouteId }: ISupportButtonsProps) {
  const { data: inkindPage } = useInkind(inkindRouteId);
  const { t } = useTranslation();
  const inkindPageViewHistory = getInkindPageViewHistory();
  const supportThroughGIK = () =>
    inkindPage?.wishList || inkindPage?.isCalendar || (inkindPage?.CTA && inkindPage?.GlobalCTA);

  const bem = bemBlock('support-buttons');

  return supportThroughGIK() ? (
    <div className={bem()}>
      <div className={bem('heading-wrapper')}>
        <Heading level={2}>Support Through Give Inkind</Heading>
      </div>
      <div className={bem('buttons')}>
        {inkindPage?.wishList && (
          <Link href={`${getBaseUrl()}inkinds/${inkindPage?.slug}/wishlist`}>
            <Button
              className={bem('from-wishlist')}
              block
              uppercase
              variant="primary"
              prepend={<SvgIcon set="gik-icons" name="Wishlist" />}
            >
              {t(translationKeys.fromWishlist)}
            </Button>
          </Link>
        )}

        {inkindPage?.isCalendar && (
          <AnchorLink to="inkind-calendar">
            <Button
              className={bem('from-calendar')}
              block
              uppercase
              variant="primary"
              prepend={<SvgIcon name="CalendarOutline" />}
            >
              {t(translationKeys.fromCalendar)}
            </Button>
          </AnchorLink>
        )}

        {inkindPage?.CTA && inkindPage?.GlobalCTA && (
          <Button
            className={bem('send-giftbox')}
            block
            uppercase
            variant="danger"
            prepend={<SvgIcon name="GiftOutline" />}
            onClick={() => openSendAGiftBoxModal(inkindPage?.routeId, inkindPageViewHistory)}
          >
            {t(translationKeys.sendAGiftBox)}
          </Button>
        )}
      </div>
    </div>
  ) : null;
}
